import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

import Text from "../Text";
import { Language, useLanguage } from "../../i18n";
import { colors } from "../../theme";

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  return (
    <View style={styles.container}>
      {(["en", "es", "fr"] as Language[]).map((option) => (
        <TouchableOpacity
          key={option}
          accessibilityLabel={`Change language to ${option}`}
          accessibilityState={{ selected: language === option }}
          onPress={() => setLanguage(option)}
          style={[styles.option, language === option && styles.activeOption]}
        >
          <Text
            variant="bold"
            style={[styles.text, language === option && styles.activeText]}
          >
            {option.toUpperCase()}
          </Text>
        </TouchableOpacity>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colors.darkestGrey,
    borderRadius: 15,
    flexDirection: "row",
    marginRight: 10,
    padding: 2,
  },
  option: {
    alignItems: "center",
    borderRadius: 12,
    minWidth: 30,
    paddingHorizontal: 5,
    paddingVertical: 4,
  },
  activeOption: { backgroundColor: colors.yellow },
  text: { color: colors.midGrey, fontSize: 9, letterSpacing: 0.4 },
  activeText: { color: colors.black },
});

export default LanguageSwitcher;
